import React, { useCallback, useState } from 'react';

import TopBarEvent from '../../../elements/TopBar/TopBarEvent';
import LoadExhibitors from '../../../loaders/LoadExhibitors';
import Validate from '../../../validate/Validate';
import WaitWhileBusy from '../../../WaitWhileBusy';
import FilterSelection from '../../EventExhibitors/elements/ExhibitorsFilterSelection';
import ExhibitorsSearchBar from '../../EventExhibitors/elements/ExhibitorsSearchBar';
import FilterScreen from '../../EventExhibitors/FilterScreen';
import Screen from '../../Screen';
import ExhibitorsInteractiveMap from '../common/ExhibitorsInteractiveMap';
import Tabs from '../common/MapTabs';

import { isExhibitorsFilterActive } from '../../../../data/filters/exhibitorsFilters';
import { useEvent } from '../../../../data/hooks/eventHooks';
import { useExhibitors, useExhibitorsFilter, useExhibitorsRecommendedFilter } from '../../../../data/hooks/exhibitor/exhibitorHooks';
import { useExhibitorsTagCategories } from '../../../../data/hooks/exhibitor/useExhibitorsTagCategories';
import { useI18n } from '../../../../data/hooks/i18nHooks';

const ExhibitorsMap = props => {
    const {eventId, default: defaultSelection} = props,
        event = useEvent(eventId),
        i18n = useI18n(),
        [showFilterScreen, setShowFilterScreen] = useState(false),
        filter = useExhibitorsFilter(eventId),
        exhibitors = useExhibitors(eventId, {filter}),
        tags = useExhibitorsTagCategories(eventId),
        recommendedFilter = useExhibitorsRecommendedFilter(eventId);

    const handleCloseFilterScreen = useCallback(() => {
            setShowFilterScreen(false);
        }, []),
        handleOpenFilterScreen = useCallback(() => {
            setShowFilterScreen(true);
        }, []);

    if (showFilterScreen) {
        return (
            <FilterScreen
                exhibitors={exhibitors}
                filterParams={filter}
                tags={tags}
                i18n={i18n}
                event={event}
                onClose={handleCloseFilterScreen}
                recommendedFilter={recommendedFilter}
            />
        );
    }

    let header = (
        <div>
            <TopBarEvent event={event} returnURL="../..">
                &nbsp;
            </TopBarEvent>
            <hr />
            <Tabs event={event} i18n={i18n} />
            {isExhibitorsFilterActive(filter) ? (
                <div>
                    <ExhibitorsSearchBar event={event} filter={filter} i18n={i18n} onOpenFilterScreen={handleOpenFilterScreen}>
                        <FilterSelection event={event} tags={tags} selectedTags={filter.tags} />
                    </ExhibitorsSearchBar>
                </div>
            ) : null}
            <hr />
        </div>
    );

    return (
        <Screen header={header}>
            <ExhibitorsInteractiveMap
                eventId={eventId}
                src={event.exhibitors_map_url}
                exhibitors={exhibitors}
                highlightExhibitors={isExhibitorsFilterActive(filter) ? exhibitors : null}
                default={defaultSelection}
            />
        </Screen>
    );
};

export default props => (
    <Validate
        validate={state => {
            if (!_(state).get(`events[${props.match.params.eventId}].event.exhibitors_map_url`)) {
                throw new Error('No exhibitors maps to show');
            }
        }}>
        <LoadExhibitors eventId={props.match.params.eventId}>
            <WaitWhileBusy>
                <ExhibitorsMap {...props.match.params} />
            </WaitWhileBusy>
        </LoadExhibitors>
    </Validate>
);
